import { IWithSummaryModel } from "src/app/modules/common/permission/api/entity/iWithSummary.model";
import {ProductStockUnitSummaryModel} from "./productStockUnitSummary.model";
import {ProductSummaryModel} from "../../../../api/entity/productSummary.model";

export class ProductStockUnitModel implements IWithSummaryModel<ProductStockUnitSummaryModel> {
    summary: ProductStockUnitSummaryModel;
    product: ProductSummaryModel;
}

